import { render, staticRenderFns } from "./book-create.vue?vue&type=template&id=4fcb748f&scoped=true"
import script from "./book-create.vue?vue&type=script&lang=js"
export * from "./book-create.vue?vue&type=script&lang=js"
import style0 from "./book-create.vue?vue&type=style&index=0&id=4fcb748f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb748f",
  null
  
)

export default component.exports